import { Textarea } from "@q4/nimbus-ui";
import { WidgetProps } from "@rjsf/core";
import React from "react";

const TextareaWidget = (props: WidgetProps): JSX.Element => {
  const { value, disabled, readonly, onChange, id } = props;
  return <Textarea id={id} value={value} onChange={onChange} disabled={disabled} readOnly={readonly} />;
};
export default TextareaWidget;
